import { Component, h, Prop } from '@stencil/core';
import { TypographyVariant, TypographyColor, UnityTypographyProps } from './types';


@Component({
  tag: 'unity-typography',
  styleUrl: 'unity-typography.css',
  shadow: true
})
export class typography implements UnityTypographyProps {
  @Prop() variant: TypographyVariant = 'body';
  @Prop() gutterBottom: boolean = false;
  @Prop() bold: boolean = false;
  @Prop() color: TypographyColor = 'main';

  private getClasses(baseClass: string): { [key: string]: boolean } {
    return {
      [baseClass]: true,
      'bold': this.bold,
      [`color-${this.color}`]: true
    };
  }

  render() {
    if (this.variant === 'body') {
      return <span class={this.getClasses('body')}><slot /></span>;
    }

    switch (this.variant) {
      case 'h1':
        return <h1 class={this.getClasses('h1')}><slot /></h1>;
      case 'h2':
        return <h2 class={this.getClasses('h2')}><slot /></h2>;
      case 'h3':
        return <h3 class={this.getClasses('h3')}><slot /></h3>;
      case 'h4':
        return <h4 class={this.getClasses('h4')}><slot /></h4>;
      case 'h5':
        return <h5 class={this.getClasses('h5')}><slot /></h5>;
      case 'h6':
        return <h6 class={this.getClasses('h6')}><slot /></h6>;
      case 'body1':
        return <p class={this.getClasses('body1')}><slot /></p>;
      case 'body2':
        return <p class={this.getClasses('body2')}><slot /></p>;
      case 'caption-text':
        return <span class={this.getClasses('caption-text')}><slot /></span>;
      case 'data-display-one':
        return <span class={this.getClasses('data-display-one')}><slot /></span>;
      case 'data-display-two':
        return <span class={this.getClasses('data-display-two')}><slot /></span>;
      case 'data-display-three':
        return <span class={this.getClasses('data-display-three')}><slot /></span>;
      case 'data-display-four':
        return <span class={this.getClasses('data-display-four')}><slot /></span>;
      case 'button':
        return <span class={this.getClasses('button')}><slot /></span>;
      default:
        return <p class={this.getClasses('body1')}><slot /></p>;
    }
  }
}
